import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MaterialPublicModule } from '../angular-material/material-public.module';

import { EduNotificationComponent } from './edu-notification/edu-notification.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialPublicModule
    ],
    declarations: [EduNotificationComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    exports: [EduNotificationComponent]
})
export class NotificationsModule { }
